var log = require('./log').log;
exports.second = function () {
  log('2');
}



//////////////////
// WEBPACK FOOTER
// ./second.js
// module id = 0
// module chunks = 0